// extracted by mini-css-extract-plugin
export default {"WorkSchedule":"I7aIh9H1","info":"gdXThALv","title":"caZj89A2","actionContent":"ghuG5e6C","workName":"EtZUBKlr","list":"jghnIKvu","item":"gCIb0jYr","active":"_8DkXYSj","el":"b5gMMbDM","name":"SEMQGDlS","value":"UZAfG2lQ","speaker":"e9udP2ih","speakerImg":"i0I5FuXG"};
    if(module.hot) {
      // 1734636562038
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  